import { Opacity as SlateOpacity } from "@faire/web--source/slate/Color";
import { Opacity } from "@faire/web-api--source/indigofair/data/Opacity";

const ZERO_OPACITY = "00";

export const getOpacityHexValue = (
  key?: keyof typeof Opacity,
  defaultValue: string = ""
) => {
  switch (key) {
    case Opacity.OPACITY_NONE:
      return ZERO_OPACITY;
    case Opacity.OPACITY_3:
      return SlateOpacity.O_03;
    case Opacity.OPACITY_5:
      return SlateOpacity.O_05;
    case Opacity.OPACITY_20:
      return SlateOpacity.O_20;
    case Opacity.OPACITY_30:
      return SlateOpacity.O_30;
    case Opacity.OPACITY_40:
      return SlateOpacity.O_40;
    case Opacity.OPACITY_50:
      return SlateOpacity.O_50;
    case Opacity.OPACITY_100:
      return "";
    default:
      return defaultValue;
  }
};
